import { IGameplayEvent } from '../State/IJoinedRoomState';

type RoomGameplayEventListener = (event: IGameplayEvent) => void;

class RoomGameplayEventBus {
    private listeners: Set<RoomGameplayEventListener> = new Set();

    public publish = (event: IGameplayEvent) => {
        Array.from(this.listeners).forEach((listener) => listener(event));
    };

    public subscribe = (listener: RoomGameplayEventListener): (() => void) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };
}

export const roomGameplayEventBus = new RoomGameplayEventBus();
